
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 916 351","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"t t1",attrs:{"d":"M66.667 235l66.667 115.52H0L66.667 235z","fill":"#2ECC71"}}),_c('path',{staticClass:"t t2",attrs:{"d":"M262.667 235l66.667 115.52H196L262.667 235z","fill":"#24AD75"}}),_c('path',{staticClass:"t t3",attrs:{"d":"M457.667 235l66.667 115.52H391L457.667 235z","fill":"#19897A"}}),_c('path',{staticClass:"t t4",attrs:{"d":"M653.667 235l66.667 115.52H587L653.667 235z","fill":"#106E7E"}}),_c('path',{staticClass:"t t5",attrs:{"d":"M848.667 235l66.667 115.52H782L848.667 235z","fill":"#095880"}})])
          )
        }
      }
    